/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ridge_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What data does it need?`)
};

const es_ridge_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué datos necesita?`)
};

const de_ridge_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Daten werden benötigt?`)
};

const nl_ridge_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke gegevens zijn nodig?`)
};

const fr_ridge_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De quelles données a-t-il besoin ?`)
};

const it_ridge_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di quali dati ha bisogno?`)
};

const pt_br2_ridge_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De que dados ele precisa?`)
};

const pt_ridge_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que dados são necessários?`)
};

const ja_ridge_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どのようなデータが必要ですか?`)
};

const zh_ridge_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需要什么样的数据？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ridge_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ridge_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ridge_faq_q4", locale)
	if (locale === "en") return en_ridge_faq_q4(inputs)
	if (locale === "es") return es_ridge_faq_q4(inputs)
	if (locale === "de") return de_ridge_faq_q4(inputs)
	if (locale === "nl") return nl_ridge_faq_q4(inputs)
	if (locale === "fr") return fr_ridge_faq_q4(inputs)
	if (locale === "it") return it_ridge_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_ridge_faq_q4(inputs)
	if (locale === "pt") return pt_ridge_faq_q4(inputs)
	if (locale === "ja") return ja_ridge_faq_q4(inputs)
	return zh_ridge_faq_q4(inputs)
};